/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeProfileRolesResponseDto } from '../models';
// @ts-ignore
import type { EmployeeSupervisorResponseDto } from '../models';
/**
 * RestEmployeeProfileApi - axios parameter creator
 * @export
 */
export const RestEmployeeProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get employee profile role
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserRoleOnEmployeeProfile: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCurrentUserRoleOnEmployeeProfile', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/roles`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get employee supervisor
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupervisor: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeSupervisor', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/supervisor`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmployeeProfileApi - functional programming interface
 * @export
 */
export const RestEmployeeProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmployeeProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get employee profile role
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserRoleOnEmployeeProfile(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeProfileRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserRoleOnEmployeeProfile(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmployeeProfileApi.getCurrentUserRoleOnEmployeeProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get employee supervisor
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSupervisor(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeSupervisorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSupervisor(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmployeeProfileApi.getEmployeeSupervisor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmployeeProfileApi - factory interface
 * @export
 */
export const RestEmployeeProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmployeeProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get employee profile role
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserRoleOnEmployeeProfile(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfileRolesResponseDto> {
            return localVarFp.getCurrentUserRoleOnEmployeeProfile(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get employee supervisor
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupervisor(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSupervisorResponseDto> {
            return localVarFp.getEmployeeSupervisor(employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmployeeProfileApi - interface
 * @export
 * @interface RestEmployeeProfileApi
 */
export interface RestEmployeeProfileApiInterface {
    /**
     * 
     * @summary Get employee profile role
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeProfileApiInterface
     */
    getCurrentUserRoleOnEmployeeProfile(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfileRolesResponseDto>;

    /**
     * 
     * @summary Get employee supervisor
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeProfileApiInterface
     */
    getEmployeeSupervisor(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSupervisorResponseDto>;

}

/**
 * RestEmployeeProfileApi - object-oriented interface
 * @export
 * @class RestEmployeeProfileApi
 * @extends {BaseAPI}
 */
export class RestEmployeeProfileApi extends BaseAPI implements RestEmployeeProfileApiInterface {
    /**
     * 
     * @summary Get employee profile role
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeProfileApi
     */
    public getCurrentUserRoleOnEmployeeProfile(employeeId: string, options?: RawAxiosRequestConfig) {
        return RestEmployeeProfileApiFp(this.configuration).getCurrentUserRoleOnEmployeeProfile(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get employee supervisor
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeProfileApi
     */
    public getEmployeeSupervisor(employeeId: string, options?: RawAxiosRequestConfig) {
        return RestEmployeeProfileApiFp(this.configuration).getEmployeeSupervisor(employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}

